$(document).ready(function () {
  /**
    $('.thumbnail-list__item:visible').find('button.thumbnail').first().click();

    const gallery = document.querySelector('media-gallery');
    
    if(gallery) {
      const slider = gallery.querySelector('slider-component');
      if (slider.onResize) slider.onResize();
    }
  **/
  
  $('.product-variants-wrp .product-varisnt-btn').on('click',function() {
    let get_image = $(this).attr("data-iamge");
    let get_url = $(this).attr("data-url");
    console.log(get_url);
    // console.log(get_image);
    $(this).closest('.link_all_pdp').find('.product-variants-wrp .product-varisnt-btn').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.link_all_pdp').find('.product_image img').attr("src",get_image);
    if($(this).closest('.leftcontent').hasClass('enable_video')){
      $(this).closest('.leftcontent').removeClass('enable_video');
      $(this).closest('.leftcontent').find('video').hide();
    }

    $(this).closest('.link_all_pdp').find("a").attr("href",get_url);
  });
  /***************************----mega-menu-start-----***********************************/

   function getBackgroundImages() {
  const images = [];
  $('#get-bg-img-col .bg-input').each(function() {
    const bgImg = $(this).attr('bg-img');
    if (bgImg) {
      images.push(bgImg);
    }
  });
  
  return images;
}

function preloadMegaMenuImages(images) {
  images.forEach((image) => {
    const img = new Image();
    img.src = image;
  });
}

const preloadImages = getBackgroundImages();

  preloadMegaMenuImages(preloadImages);
  
    $("ul.list-menu  li.ctm-mega-chage-bg.ctm-mega-listmn").hover(
    function () {
      var get_this_item = $(this).find('span').text().replace(/\s+/g, "");

      const parent = this.parentElement;
      const distance =
        this.getBoundingClientRect().left -
        parent.getBoundingClientRect().left -
        parent.clientLeft;

      var margin_left = distance + 'px';

      $("li.ctm-mega-chage-bg.ctm-mega-listmn").removeClass("sec-active");
      $(this).addClass("sec-active");
      $('.mega-custom-outer .ctm-mega-menu__list').hide().removeClass('active');
      $('.mega-custom-outer .mega-custom-featured').hide().removeClass('active');

      $('.mega-custom-outer .ctm-mega-menu__list.clas-show-' + get_this_item)
        .css('margin-left', margin_left)
        .show()
        .addClass('active');
      $('.mega-custom-outer .mega-custom-featured[data-link="' + get_this_item + '"]').show().addClass('active');
    },
    function () {
      $("sticky-header#ctm-nav-sticky").css("background-color", "#000");
      
    }
  );
  
  $(".ctm-mega-chage-bg").hover(
    function () {
      $('.mega-custom-outer').show();
      $('body').addClass('mega-menu-active');
      
      $(".ctm-mega-chage-bg").removeClass("active");
      $(this).addClass("active");

      if($(this).closest('.ctm-mega-menu__list').length){
        $('.mega-custom-outer .ctm-mega-menu__list').removeClass('active');
        $(this).closest('.ctm-mega-menu__list').addClass('active');
      };
     
      var get_data_active = $(this).closest('.ctm-mega-menu__list').attr('data-active');

      $('li.ctm-mega-chage-bg.ctm-mega-listmn').removeClass('sec-active');
      $('li.ctm-mega-chage-bg.ctm-mega-listmn.show-'+get_data_active).addClass('sec-active');
      
      var get_this_title = $(this).find("a").text().replace(/\s+/g, "");
      var get_this_parent = $(this).find("a").attr('data-parent');
      
      $("div#get-bg-img-col input.bg-input").each(function () {
        var get_nav_item_color = $(this).attr("nav_item_color");
        var get_nav_item = $(this).attr("data-nav-item").replace(/\s+/g, "");
        var get_nav_parent = $(this).attr("data-nav-parent").replace(/\s+/g, "");
        var get_bg_img = $(this).attr("bg-img");
        var get_bg_color = $(this).attr("bg-color");
        
        if(get_this_title === get_nav_item || get_this_parent == get_nav_parent) {
          if (get_nav_item_color) {
            $("sticky-header#ctm-nav-sticky").addClass("black-nav-item");
          } 
          else {
            $("sticky-header#ctm-nav-sticky").removeClass("black-nav-item");
          }

          if (get_bg_img) {
            $("sticky-header#ctm-nav-sticky").css(
              "background-image",
              "url(" + get_bg_img + ")"
            );
          } else {
            $("sticky-header#ctm-nav-sticky").css("background-image", "none");
          }
          if (get_bg_color) {
            $("sticky-header#ctm-nav-sticky").css(
              "background-color",
              get_bg_color
            );
          }
        }
      });
    },
    function () {
      $(".ctm-mega-chage-bg").removeClass("active");
      //$("sticky-header#ctm-nav-sticky").css("background-image", "none");
      //$("sticky-header#ctm-nav-sticky").css("background-color", "#000");
      //$("sticky-header#ctm-nav-sticky").removeClass("black-nav-item");
      // $('.mega-custom-outer').hide();
      // $('body').removeClass('mega-menu-active');
    }
  );

  
   $(".mega-custom-wrp, .header__inline-menu").hover(
    function () {
    },
      function () {
        $('.mega-custom-outer').hide();
      $('body').removeClass('mega-menu-active');
      $("sticky-header#ctm-nav-sticky").css("background-color", "#000");
      }
     );

  /***************************----mega-menu-end-----***********************************/

  $(
    ".grid__item.product__media-wrapper .product__media-list .deferred-media__poster"
  ).click();
  $(".product__media-wrapper .product__media-item video").each(function () {
    if (this.paused) {
      this.play();
    }
  });
  $("video").each(function () {
    if (
      $(this).attr("autoplay") === "autoplay" ||
      $(this).attr("autoplay") === "true"
    ) {
      if (this.paused) {
        this.play();
      }
    }
  });

  var get_var_url = window.location.href;
  var variantId = get_var_url.match(/variant=(\d+)/);
  if (variantId && variantId.length > 1) {
   // console.log(variantId[1]);
    $(".show_variant_aval_qunt.id--" + variantId[1]).show();
  }

  $(".accordion_tab_title").click(function () {
    $(this)
      .toggleClass("active")
      .next(".accordion_tab_content")
      .slideToggle()
      .parent()
      .siblings()
      .find(".accordion_tab_content")
      .slideUp()
      .prev()
      .removeClass("active");
  });

  $(".as_seen_on_slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    autoplaySpeed: 1500,
    autoplay: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  let touchStartX = 0;
  let touchEndX = 0;

  const gallery = document.querySelector('.product__media-wrapper');

  if (gallery) {
    gallery.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    gallery.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;

      handleSwipe();
    }, { passive: true });
  }

  function handleSwipe() {
    const threshold = 50; // minimum swipe distance
    const distance = touchEndX - touchStartX;

    if (Math.abs(distance) < threshold) {
      return;
    }

    if (distance < 0) {
      // Swipe left → next image
      $('.custom_slider_button_next').click();
    } else {
      // Swipe right → previous image
      $('.custom_slider_button_pre').click();
    }
  }

  $(".custom_slider_button_next").click(function () {
    let $current = $(
      '.product--medium .product__media-wrapper .slider--mobile .thumbnail[aria-current="true"]'
    ).closest(".thumbnail-list__item");
    let $next = $current.next();
    
    while ($next.length && $next.css("display") === "none") {
      $next = $next.next();
    }

    if ($next.length) {
      $next.find(".thumbnail").click();
    }
  });
  
  $(".custom_slider_button_pre").click(function () {
    let $current = $(
      '.product--medium .product__media-wrapper .slider--mobile .thumbnail[aria-current="true"]'
    ).closest(".thumbnail-list__item");
    let $prev = $current.prev();

    while ($prev.length && $prev.css("display") === "none") {
      $prev = $prev.prev();
    }

    if ($prev.length) {
      $prev.find(".thumbnail").click();
    }
  });

  /***blog post_slideres--start***/
  $(".first_blog_images_slider_first").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
  });

  $(".ctm_first_blog_main_wrp_slider").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
  });

  $(".mobile_ctm_slider").slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    slidesToShow: 1.1,
    centerPadding: "150px",
  });

  /***blog post_slideres--end***/

  $(".logo_text_block_counter_slider").slick({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    slidesToShow: 1,
  });

  if (window.innerWidth > 750) {
    $(".image_overlay_blocks_slider").slick({
      dots: true,
      infinite: false,
      speed: 500,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: false,
      slidesToShow: 1,
      adaptiveHeight: true,
    });
  }

  if (window.innerWidth < 750) {
    $(".images_grid_inner").slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
    });
  }
});

/**
  Raide Research Customization
  Author: Patrick Gephart <pmgephart@gmail.com>
**/

document.addEventListener('DOMContentLoaded', function () {
  const radios = document.querySelectorAll('.raide-newsletter input[name="newsletter_list"]');
  const tagsInput = document.getElementById('raide-newsletter-tags');

  if(!radios.length || !tagsInput) return;

  radios.forEach(radio => {
    radio.addEventListener('change', function () {
        tagsInput.value = this.value;
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const radios = document.querySelectorAll('.raide-footer-newsletter input[name="newsletter_list"]');
  const tagsInput = document.getElementById('raide-footer-newsletter-tags');

  if(!radios.length || !tagsInput) return;

  radios.forEach(radio => {
    radio.addEventListener('change', function () {
        tagsInput.value = this.value;
    });
  });
});

$(document).ready(function() {
  raideAnnouncementVisibility();
  
  if($(window).width() <= 749) {
    raideResizeMobileVideo(false);
  }

  $(window).resize(function() {
    if($(window).width() <= 749) {
      raideResizeMobileVideo(false);
    }
    else {
      raideResizeMobileVideo(true);
    }
  });

  $(window).on('scroll', () => {
    raideAnnouncementVisibility();
  });
});

function raideResizeMobileVideo(reset) {
  $(document).ready(function() {
    if(reset) {
      $('.leftcontent.enable_video video.video_item').css('width', '100%');
      $('.leftcontent.enable_video video.video_item').css('height', '100%');
    }
    else {
      var imgs = $('.product_banner .leftcontent.enable_image img');

      if(imgs.length) {
        $('.leftcontent.enable_video video.video_item').width(imgs[0].width);
        $('.leftcontent.enable_video video.video_item').height(imgs[0].width);
      }
    }
  });
}

function raideAnnouncementVisibility() {
  $(document).ready(function() {
    var top_of_element = $(".announcement-bar-section").offset().top;
    var bottom_of_element = $(".announcement-bar-section").offset().top + $(".announcement-bar-section").outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        $('header.header').removeClass('announcement-invisible');
    } else {
        $('header.header').addClass('announcement-invisible');
    }
  });
};

/** product grid item variants **/

const prodGridvariantsBtn = document.querySelectorAll('.product-grid-item .product-varisnt-btn');

function productGridUpdateVariantChange() {
    const parent = this.parentNode;
    const parentItem = this.closest('.product-grid-item');
    const variantImg = this.dataset.image;
    const variantUrl = this.dataset.url;
    const variantVideo = this.dataset.video;
    const variantBtns = parent.querySelectorAll('.product-varisnt-btn');
    const links = parentItem.querySelectorAll('a');

    const videoElement = parentItem.getElementsByClassName('video-wrapper');
    const imageElement = parentItem.getElementsByClassName('image-wrapper');
    
    if(variantVideo == 1) {
        if(videoElement.length > 0) {
            videoElement[0].style.display = "block";
        }

        if(imageElement.length > 0) {
            imageElement[0].style.display = "none";
        }
    }
    else {
        if(videoElement.length > 0) {
            videoElement[0].style.display = "none";
        }

        if(imageElement.length > 0) {
            imageElement[0].style.display = "block";
            imageElement[0].querySelector('img').src = variantImg;
        }
    }

    variantBtns.forEach(variant => variant.classList.remove('active'));
    links.forEach(link => link.href = variantUrl);

    this.classList.add('active');
}

for(var i = 0; i < prodGridvariantsBtn.length; i++) {
    prodGridvariantsBtn[i].addEventListener("click", productGridUpdateVariantChange, false);
}

/**
 * resizes each slide in hero slider when page loads or resizes
 */

raideHeroSliderResize();
window.addEventListener("resize", raideHeroSliderResize);

function raideHeroSliderResize() {
  const announcementBar = document.querySelectorAll('.announcement-bar-section');
    
  if(announcementBar.length) {
    const height = announcementBar[0].offsetHeight;

    if(height > 0) {
      const heroSlides = document.querySelectorAll('.raide-hero-slider .hero-slider .hero-slide');

      if(heroSlides.length) {
        heroSlides.forEach(function(slide) {
          slide.style.height = `calc(100vh - ${height}px)`; 
        });
      }

      const heroVideo = document.querySelector('.raide-1-col.hero-position .video-wrapper video');

      if(heroVideo) {
        heroVideo.style.height = `calc(100vh - ${height}px)`; 
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  equalizeSlideHeights();
});

function equalizeSlideHeights() {
  let maxHeight = 0;
  const cells = document.querySelectorAll('.raide-product-grid .collection-listing .product-grid-item');

  // Reset heights first
  cells.forEach(cell => cell.style.height = 'auto');

  // Find the tallest
  cells.forEach(cell => {
    const height = cell.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  // Set all to same height
  cells.forEach(cell => cell.style.height = maxHeight + 'px');
}
/*
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.footer .grid__item.footer-block--men:not(.exclude)');

  console.log(links);
});
*/